<template>
  <PButton
    class="flex items-center justify-center rounded-full font-semibold"
    :disabled="is_disabled || is_loading || null"
    :size="size"
    @click.stop="submit"
  >
    <div
      v-if="iconFontawesome || is_loading"
      class="flex items-center justify-center"
    >
      <FontAwesomeIcon
        v-if="!is_loading"
        :icon="iconFontawesome"
      />
      <FontAwesomeIcon
        v-else
        icon="spinner"
        pulse
      />
    </div>
    <div>
      <slot
        v-if="is_loading"
        name="loadingText"
      >
        {{ $t('button.actions.loading') }}
      </slot>
      <slot v-else />
    </div>
  </PButton>
</template>

<script setup>
import { useRouter } from 'vue-router';

const actions_to_fontawesome_icon = Object.freeze({
  approve: 'check',
  create: 'plus',
  download: 'download',
  invitation: 'envelope',
  new: 'plus',
  move: 'shuffle',
  publish: ['far', 'eye'],
  save: ['far', 'floppy-disk'],
  send: 'paper-plane',
  share: 'share',
  sign: ['far', 'signature'],
  unpublish: ['far', 'eye-slash'],
  update: 'save',
  upload: 'upload',
  unlock: ['far', 'unlock'],
  info: ['far', 'circle-info'],
});

const props = defineProps({
  action: {
    type: String,
    default: null,
    validator: (prop) =>
      [
        'approve',
        'create',
        'download',
        'invitation',
        'new',
        'move',
        'publish',
        'save',
        'send',
        'share',
        'sign',
        'unpublish',
        'update',
        'upload',
        'unlock',
        'info',
      ].includes(prop),
  },
  is_disabled: { type: Boolean },
  is_loading: { type: Boolean },
  to: { type: Object, default: null },
  size: { type: String, default: 'small' },
});

const emit = defineEmits(['onClick']);

const router = useRouter();

const iconFontawesome = actions_to_fontawesome_icon[props.action];

function submit() {
  if (props.is_loading || props.is_disabled) return;
  if (props.to) {
    router.push(props.to);
    return;
  }
  emit('onClick');
}
</script>
